<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i *ngIf="mode == 'create'" class="pi pi-plus-circle mr-1 title-card-icon"></i>
            <i *ngIf="mode == 'edit'" class="pi pi-pencil mr-1 title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{(mode == 'create' ? 'misc.creation.device' : 'misc.edition.device') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4 xl:col-3">
    <p-timeline [value]="items" align="left" styleClass="timeline-hidden-opposite lg:pr-2">
      <ng-template pTemplate="marker" let-item>
        <span
          class="custom-marker p-shadow-1"
          [class]="(item.index != currentStep) ? (item.index < currentStep) ? 'step-completed' : 'step-inactive' : 'step-active'"
        >
          <i class="text-white" [ngClass]="(item.index >= currentStep) ? item.icon : 'pi pi-check'"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-item>
        <div class="card flex justify-content-between align-items-center mb-4">
          <h4 [class]="(item.index != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'">
            {{item.label | transloco}}
          </h4>
          <i
            *ngIf="item.description"
            [class]="(item.index != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'"
            [pTooltip]="item.description | transloco"
            tooltipPosition="top"
            class="pi pi-info-circle text-xl"
            tooltipStyleClass="device-info-tooltip"
          ></i>
        </div>
      </ng-template>
    </p-timeline>
  </div>

  <div class="col-12 lg:col-8 xl:col-9" *ngIf="formLoaded">
    <div *ngIf="currentStep == 0">
      <app-devices-form-info
        [(device)]="device"
        [(template)]="template"
        [(defaultDevice)]="defaultDevice"
        (nextStep)="onNextStep()"
        [mode]="mode"
        (cancel)="onCancel($event)"
        (tenantChange)="tenantChanged()"
        (organizationChange)="organizationChanged()"
      ></app-devices-form-info>
    </div>
    <div *ngIf="currentStep == 1">
      <app-devices-form-measurements
        [(deviceMeasurements)]="deviceMeasurements"
        [tenant]="device.tenant"
        (cancel)="onCancel($event)"
        [mode]="mode"
        (previousStep)="onPreviousStep()"
        (nextStep)="onNextStep()"
      ></app-devices-form-measurements>
    </div>
    <div *ngIf="currentStep == 2">
      <app-devices-form-expressions
        [deviceMeasurements]="deviceMeasurements"
        [(deviceExpressions)]="deviceExpressions"
        [tenant]="device.tenant"
        [mode]="mode"
        (previousStep)="onPreviousStep()"
        (nextStep)="onNextStep()"
        (cancel)="onCancel($event)"
      ></app-devices-form-expressions>
    </div>
    <div *ngIf="currentStep == 3">
      <app-devices-form-properties
        [(deviceProperties)]="deviceProperties"
        [tenant]="device.tenant"
        [mode]="mode"
        (previousStep)="onPreviousStep()"
        (nextStep)="onNextStep()"
        (cancel)="onCancel($event)"
      ></app-devices-form-properties>
    </div>
    <div *ngIf="currentStep == 4">
      <app-devices-form-integration-modules
        [(integrationModules)]="integrationModules"
        [tenant]="device.tenant"
        [mode]="mode" (previousStep)="onPreviousStep()"
        (nextStep)="onNextStep()"
        (cancel)="onCancel($event)"
      ></app-devices-form-integration-modules>
    </div>
    <div *ngIf="currentStep == 5">
      <app-devices-form-assets
        [(asset)]="asset"
        [(assetSearchData)]="assetSearchData"
        [organization]="device.organization"
        [tenant]="device.tenant"
        [defaultAssetRepresentation]="defaultDevice?.defaultAssetRepresentation"
        [mode]="mode"
        (previousStep)="onPreviousStep()"
        (nextStep)="onNextStep()"
        (cancel)="onCancel($event)"
      ></app-devices-form-assets>
    </div>
    <div *ngIf="currentStep == 6">
      <div class="card">
        <div class="flex flex-column p-1 sm:p-3">

          <h2>{{'model.device' | transloco}} {{device.serialNumber}}</h2>

          <h4 class="mt-4 bold">{{'common.information' | transloco}}</h4>
          <div class="grid my-2" *ngIf="asset">
            <div class="flex flex-column col-12 lg:col-6 xl:col-4">
              <div>
                <p class="bold p-0 m-0">{{'attribute.description' | transloco}}</p>
                <p [class.font-italic]="!device.description">{{device.description ? device.description : ("empty.description" | transloco)}}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'model.tenant' | transloco}}</p>
                <p>{{device.tenant.name}}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'model.organization' | transloco}}</p>
                <p [class.font-italic]="!device.organization">{{device.organization ? device.organization.name : ('empty.organization' | transloco)}}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'attribute.category' | transloco}}</p>
                <p [class.font-italic]="!device.deviceCategory">{{device.deviceCategory ? device.deviceCategory.name : ('empty.category' | transloco)}}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{'model.asset' | transloco}}</p>
                <p [class.font-italic]="!asset">{{asset ? asset.alias : ('empty.asset' | transloco)}}</p>
              </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-8">
              <div *ngIf="asset" id="deviceConfirmationMap"></div>
            </div>
          </div>

          <div *ngIf="!asset" class="grid">
            <div class="col-12 sm:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.description' | transloco}}</p>
              <p [class.font-italic]="!device.description">{{device.description ? device.description : ("empty.description" | transloco)}}</p>
            </div>
            <div class="col-12 sm:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'model.tenant' | transloco}}</p>
              <p>{{device.tenant.name}}</p>
            </div>
            <div class="col-12 sm:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'model.organization' | transloco}}</p>
              <p [class.font-italic]="!device.organization">{{device.organization ? device.organization.name : ('empty.organization' | transloco)}}</p>
            </div>
            <div class="col-12 sm:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.category' | transloco}}</p>
              <p [class.font-italic]="!device.deviceCategory">{{device.deviceCategory ? device.deviceCategory.name : ('empty.category' | transloco)}}</p>
            </div>
            <div class="col-12 sm:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'model.asset' | transloco}}</p>
              <p [class.font-italic]="!asset">{{asset ? asset.alias : ('empty.asset' | transloco)}}</p>
            </div>
          </div>

          <h4 class="mt-6 bold">{{'attribute.technicalDetails' | transloco}}</h4>
          <div class="my-2">
            <ngx-json-viewer *ngIf="device.technicalDetails" [json]="device.technicalDetails"></ngx-json-viewer>
            <p *ngIf="!device.technicalDetails" class="text-center"><i>{{'empty.technicalDetails' | transloco}}</i></p>
          </div>

          <h4 class="mt-6 bold">{{'model.sensors' | transloco}}</h4>
          <div class="my-2">
            <p-table [value]="deviceMeasurements" *ngIf="deviceMeasurements.length > 0" styleClass="p-datatable-striped">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'attribute.name' | transloco}}</th>
                  <th>{{'attribute.description' | transloco}}</th>
                  <th>{{'attribute.alias' | transloco}}</th>
                  <th>{{'model.measurementType' | transloco}}</th>
                  <th>{{'attribute.sampleRate' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-measurement>
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                    {{measurement.name}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                    {{measurement.description}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                    {{measurement.alias}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'model.measurementType' | transloco}}</span>
                    {{measurement.measurementType.sensor}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.sampleRate' | transloco}}</span>
                    {{measurement.sampleRate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p *ngIf="deviceMeasurements.length == 0" class="text-center"><i>{{'empty.measurements' | transloco}}</i></p>
          </div>

          <h4 class="mt-6 bold">{{'model.expressions' | transloco}}</h4>
          <div class="my-2">
            <p-table [value]="deviceExpressions" *ngIf="deviceExpressions.length > 0" styleClass="p-datatable-striped">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'attribute.name' | transloco}}</th>
                  <th>{{'attribute.description' | transloco}}</th>
                  <th>{{'attribute.alias' | transloco}}</th>
                  <th>{{'model.measurementType' | transloco}}</th>
                  <th>{{'attribute.expression' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-measurement>
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                    {{measurement.name}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                    {{measurement.description}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                    {{measurement.alias}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'model.measurementType' | transloco}}</span>
                    {{measurement.measurementType.sensor}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.sampleRate' | transloco}}</span>
                    {{measurement.expression}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p *ngIf="deviceExpressions.length == 0" class="text-center"><i>{{'empty.expressions' | transloco}}</i></p>
          </div>

          <h4 class="mt-6 bold">{{'model.properties' | transloco}}</h4>
          <div class="my-2">
            <p-table [value]="deviceProperties" *ngIf="deviceProperties.length > 0" styleClass="p-datatable-striped">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'attribute.name' | transloco}}</th>
                  <th>{{'attribute.value' | transloco}}</th>
                  <th>{{'model.propertyType' | transloco}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-property>
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                    {{property.name}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.value' | transloco}}</span>
                    {{property.value}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'model.propertyType' | transloco}}</span>
                    {{property.propertyType?.name}} {{property.propertyType?.unit ? ('(' + property.propertyType.unit + ')') : ''}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <p *ngIf="deviceProperties.length == 0" class="text-center"><i>{{'empty.properties' | transloco}}</i></p>
          </div>

          <h4 class="mt-6 bold">{{'model.integrationModules' | transloco}}</h4>
          <div class="my-2">
            <div class="col-12" *ngFor="let module of integrationModules; let index=index">
              <div class="module-card grid p-3">
                <div class="col-12 lg:col-6 xl:col-3">
                  <div>
                    <label class="bold">{{'attribute.integrationCode' | transloco}}</label><br>
                  </div>
                  <div>
                    <p>{{module.integrationCode}}</p>
                  </div>
                </div>
                <div class="col-12 lg:col-6 xl:col-3">
                  <div>
                    <label class="bold">{{'attribute.integrationIdentifier' | transloco}}</label><br>
                  </div>
                  <div>
                    <p>{{module.integrationIdentifier}}</p>
                  </div>
                </div>
                <div class="col-12 lg:col-6 xl:col-3">
                  <div>
                    <label class="bold">{{'model.decoder' | transloco}}</label><br>
                  </div>
                  <div>
                    <p [class.font-italic]="!module.decoder">
                      {{module.decoder ? module.decoder.name : ('empty.decoder' | transloco) }}
                    </p>
                  </div>
                </div>
                <div class="col-12 lg:col-6 xl:col-3">
                  <div>
                    <label class="bold">{{'model.encoder' | transloco}}</label><br>
                  </div>
                  <div>
                    <p [class.font-italic]="!module.encoder">
                      {{module.encoder ? module.encoder.name : ('empty.encoder' | transloco) }}
                    </p>
                  </div>
                </div>
                <div class="col-12">
                  <div>
                    <label class="bold">{{'attribute.technicalDetails' | transloco}}</label>
                  </div>
                  <div class="col-12 p-3" *ngIf="module.technicalDetails">
                    <ngx-json-viewer [json]="module.technicalDetails"></ngx-json-viewer>
                  </div>
                  <p *ngIf="!module.technicalDetails"><i>{{'empty.technicalDetails' | transloco}}</i></p>
                </div>
              </div>
            </div>
            <p *ngIf="integrationModules.length == 0" class="text-center"><i>{{'empty.integrationModules' | transloco}}</i></p>
          </div>
          <div class="mt-6">
            <div class="flex flex-column sm:flex-row justify-content-between">
              <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
                <button
                  [label]="'common.previous' | transloco"
                  (click)="onPreviousStep()"
                  pButton
                  pRipple
                  class="flex-1 sm:flex-none"
                  icon="pi pi-angle-left"
                  iconPos="left"
                ></button>
                <button
                  [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
                  (click)="persistDeviceData()"
                  [loading]="persistingChanges"
                  class="p-button-primary ml-2 flex-1 sm:flex-none"
                  pButton
                  pRipple
                ></button>
              </div>
              <button
                [label]="'common.cancel' | transloco"
                (click)="onCancel()"
                class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
                pButton
                pRipple
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
